import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

export type PrivacyPolicyAction =
  | ActionType<typeof actions.fetchTermRequest>
  | ActionType<typeof actions.fetchTermSuccess>
  | ActionType<typeof actions.fetchTermFail>
  | ActionType<typeof actions.fetchPrivacyPolicyRequest>
  | ActionType<typeof actions.fetchPrivacyPolicySuccess>
  | ActionType<typeof actions.fetchPrivacyPolicyFail>

export enum PrivacyPolicyActionTypes {
  TERM_REQUEST = '@@privacyPolicy/TERM_REQUEST',
  TERM_SUCCESS = '@@privacyPolicy/TERM_SUCCESS',
  TERM_FAIL = '@@privacyPolicy/TERM_FAIL',
  PRIVACY_POLICY_REQUEST = '@@privacyPolicy/PRIVACY_POLICY_REQUEST',
  PRIVACY_POLICY_SUCCESS = '@@privacyPolicy/PRIVACY_POLICY_SUCCESS',
  PRIVACY_POLICY_FAIL = '@@privacyPolicy/PRIVACY_POLICY_FAIL'
}

// export interface PrivacyPolicyType {
//   privacyPolicy: ProfilePayloadType
// }

export interface PrivacyPolicyState {
  privacyPolicy: PrivacyPolicyType
  term: TermType
}

export interface PrivacyPolicyType {
  htmlDocument: string
}
export interface TermType {
  htmlDocument: string
}
